import { useReducer, useMemo } from 'react';

import reducer, { defaultState, PaymentsState } from './reducer';
import { ActionTypes, PayloadInterface } from './actionTypes';

export interface PaymentsActions {
    setShouldShow: (payload: PayloadInterface) => void;
}

export interface PaymentsSheetState {
    state: PaymentsState;
    actions: PaymentsActions;
}

export default function usePaymentsSheetState(): PaymentsSheetState {
    const [state, dispatch] = useReducer(reducer, defaultState);
    const actions: PaymentsActions = useMemo(
        () => ({
            setShouldShow: (payload: PayloadInterface): void =>
                dispatch({
                    type: ActionTypes.SET_SHOULD_SHOW_SHEET,
                    payload,
                }),
        }),
        [dispatch],
    );
    return useMemo(
        () => ({
            state,
            actions,
        }),
        [state, actions],
    );
}
